module.exports = __webpack_public_path__ + "static/media/nft-20.f12529fe.jpg";